export default __webpack_public_path__ + "static/media/986.5614ca28.gif";